import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { UserProvider } from '@CONTEXTS';
import { AppRouter } from '@MASTER';
import { useAuthority } from '@HOOKS';
import Users from './users';
import CompanySettings from './company-settings';

const Deliveries = () => {
  let { path } = useRouteMatch();

  return (
    <div className="app-definitions">
      {useAuthority('USER_MANAGEMENT') && (
        <AppRouter path={`${path}/users`} title="Kullanıcı Yönetimi">
          <UserProvider>
            <Users />
          </UserProvider>
        </AppRouter>
      )}
      {useAuthority('COMPANY_SETTINGS') && (
        <AppRouter path={`${path}/company-settings`} title="Firma Ayarları">
          <CompanySettings />
        </AppRouter>
      )}
    </div>
  );
};

export default Deliveries;
